import {Component, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {BaseComponent} from '../BaseComponent';
import {TimetableService} from './timetable.service';
import {EmailTemplateModel} from '../../models/EmailTemplateModel';
import {BehaviorSubject} from 'rxjs';
import {User} from '../../models/User';
import {MultiDatepickerComponent} from '../general-components/multi-datepicker/multi-datepicker.component';
import {ChipsAutocompleteComponent} from '../general-components/chips-autocomplete/chips-autocomplete.component';

@Component({
  selector: 'app-timetable',
  templateUrl: './timetable.component.html',
  styleUrls: ['./timetable.component.scss']
})
export class TimetableComponent extends  BaseComponent implements OnInit {

  activeTimetableOptionList: boolean[] = [];
  emailTemplateList$: BehaviorSubject<EmailTemplateModel[]> = new BehaviorSubject<EmailTemplateModel[]>([]);
  // mailingListList$: BehaviorSubject<Array<User[]>> = new BehaviorSubject<Array<User[]>>([]);
  emailTemplateList: EmailTemplateModel[];

  @ViewChild(MultiDatepickerComponent) multiDatepickerComponent;
  @ViewChild(ChipsAutocompleteComponent) chipsAutocompleteComponent;

  constructor(private http: HttpClient, router: Router, route: ActivatedRoute, private timetableService: TimetableService) {
    super(route, router);
  }

  ngOnInit() {
    this.emailTemplateList$.subscribe(
      res => {
        this.activeTimetableOptionList = [];
        res.forEach( t => {
          this.activeTimetableOptionList.push(false);
        });
      }
    );

    this.timetableService.getAllTemplates().subscribe(
      templates => {
        console.log('getAllTemplates  ', templates);
        // this.timetableService.getAllTimetableMailingList(templates).subscribe(
        //   mailingList => {
        //     console.log('get all mailing list   ', mailingList);
        //     templates.forEach((t, index) => {
        //       t.mailingList = mailingList[index];
        // //     });
        //   }, err => {
        //     console.log('get all mailing list err    ', err);
        //   }
        // );
        this.emailTemplateList$.next(templates);
        this.emailTemplateList = templates;
        this.emailTemplateList.forEach(t => {
          t.dateListByTemplate = t.dateListByTemplate.map(d => d instanceof Date ? d : new Date(d));
        });
      }, err => {
        console.log('getAllTemplates err    ', err);
      }
    );
  }

  selectTimetable(index: number) {
    this.activeTimetableOptionList.fill(false);
    this.activeTimetableOptionList[index] = true;
  }

  closeTimetable(index: number) {
    this.activeTimetableOptionList[index] = false;
  }

  saveTimetable(timetableIndex: number) {
    const dates = this.multiDatepickerComponent.model;
    const sendTo = this.chipsAutocompleteComponent.selectedUserList;

    console.log('save timetable    ', dates, sendTo);

    this.timetableService.saveTimetable(this.emailTemplateList[timetableIndex].id, sendTo, dates).subscribe(res => {
      console.log(res);
    });
  }
}
